import React from 'react'
import { Table } from 'lucide-react'

const DataTable = () => {
  return (
    <div className="p-4 w-full">
      <h4 className="text-lg font-semibold mb-2">財務データ</h4>
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-gray-200">
            <th className="p-2 text-left">項目</th>
            <th className="p-2 text-right">金額</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="p-2">売上高</td>
            <td className="p-2 text-right">¥10,000,000</td>
          </tr>
          <tr>
            <td className="p-2">営業利益</td>
            <td className="p-2 text-right">¥2,500,000</td>
          </tr>
          <tr>
            <td className="p-2">純利益</td>
            <td className="p-2 text-right">¥1,800,000</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default DataTable